import { useInScopeModel, useWatchableValue } from '../../actions/framework';
import { GraphModel } from '../../graph/graph.model';
import { NavItem, SideBarSection } from './types';
import { useTabManager } from '../../tab-manager/tab-manager';
import { Routes } from '../../routes';
import { SidebarSection } from './common';
import { IconName } from '@cotera/client/app/components/ui/icon';

const matchesQuickFixTabRoute = (
  activeTab: string | null,
  itemName: string,
  itemType: 'agent' | 'dataset'
) => {
  const prefix = itemType === 'agent' ? '/agent/' : '/dataset/';
  return activeTab === `${prefix}${encodeURIComponent(itemName)}`;
};

export const QuickFix = () => {
  const model = useInScopeModel(GraphModel)!;
  const tabManager = useTabManager();
  const graph = useWatchableValue(model.graph);

  const quickFixItems: NavItem[] = graph.quickFix.map((item): NavItem => {
    const node = graph.nodeMap[item.name];
    const isAgent = node?.t === 'agent';
    const icon: IconName = isAgent ? 'sparkles' : 'table';
    const route = isAgent
      ? Routes.agent.forId(item.name).toString()
      : Routes.dataset.forId(item.name).toString();

    return {
      t: 'item' as const,
      title: item.name,
      icon,
      isActive: () =>
        tabManager.activeTab !== null &&
        matchesQuickFixTabRoute(
          tabManager.activeTab,
          item.name,
          isAgent ? 'agent' : 'dataset'
        ),
      onClick: () => {
        tabManager.push({
          route,
          title: item.name,
          displayTitle: item.name.split('/').pop()!,
          icon,
        });
      },
    };
  });

  // Don't render anything if there are no quick fix items
  if (quickFixItems.length === 0) {
    return null;
  }

  const quickFixSection: SideBarSection = {
    title: 'Quick Fix',
    items: quickFixItems,
  };

  return <SidebarSection section={quickFixSection} />;
};
